import { useSelector } from "react-redux";
import { getAppUser } from "../../../app/appSelectors";
import useZendeskWebWidgetInstance from "./useZendeskWebWidgetInstance";
import { getIsZendeskInitedSelector } from "../zendeskSelectors";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { useEffect } from "react";

function useZendeskSetConversationTags() {
    const isWebWidgetInited = useSelector(getIsZendeskInitedSelector);
    const user = useSelector(getAppUser);
    const zendeskWebWidgetInstance = useZendeskWebWidgetInstance();
    const { locale } = useLangContext();

    useEffect(() => {
        if (!isWebWidgetInited) {
            return;
        }
        const conversationTags = [];
        if (locale) {
            conversationTags.push(`locale_${locale}`);
        }
        if (user.user_status) {
            conversationTags.push(`status_${user.user_status}`);
        }

        zendeskWebWidgetInstance.setConversationTags(conversationTags);
    }, [isWebWidgetInited, locale, user, zendeskWebWidgetInstance]);
}

export default useZendeskSetConversationTags;
